var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:'share-network-' + _vm.key,attrs:{"href":"javascript:void(0)"},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }